<mat-dialog-content class="mat-typography">
    <p>{{ 'VC-DELETE-CONFIRMATION-DIALOG.DELETE-MESSAGE-CONFIRMATION' | translate }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button class="delete-cancel-action-btn" mat-button mat-dialog-close>{{ 'DATE-RANGE-DIALOG.CANCEL' | translate }}</button>
    <button class="delete-message-action-btn" mat-flat-button [mat-dialog-close]="true" cdkFocusInitial>{{ 'PIN-CLEAR-DIALOG.DELETE' | translate }}</button>
</mat-dialog-actions>
